class TSTierRewards extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.dynamicData = JSON.parse(this.querySelector("[data-dynamic-data]").textContent);

    window.addEventListener("aftersell-upcart:public-events:cart-updated", (e) => {
      this.updateBarInfo(e.detail.cart.totalBeforeDiscounts);
    })
    window.addEventListener("aftersell-upcart:public-events:cart-loaded", (e) => {
      this.updateBarInfo(e.detail.cart.totalBeforeDiscounts);
    })
    this.initClickEvents();
  }

  updateBarInfo(cartTotal) {
    this.classList.add("initiated");
    let nextRewardShowed = false;

    this.dynamicData.forEach((step, index) => {
      const stepRequirements = step.requirements * 100;
      const stepRequirementsLocalCurrency = Math.round(parseFloat(Shopify.currency.rate) * stepRequirements);

      const stepBlock = this.querySelector(`[data-step="${step.index}"]`);
      const preogressBar = stepBlock.querySelector("[data-bar]");

      const isLastStep = index + 1 === this.dynamicData.length;

      stepBlock.querySelector("[data-requirement]").innerHTML = window.upcartFormatMoney({ cents: stepRequirementsLocalCurrency });
      
      if (cartTotal >= stepRequirementsLocalCurrency) {
        
        stepBlock.classList.add("completed");
        preogressBar.style.width = "100%";
        preogressBar.setAttribute("data-bar", "");

        if (isLastStep) {
          this.querySelector("[data-title]").innerHTML = step.succesTitle;
          this.querySelector("[data-subtitle-desk]").innerHTML = "";
          this.querySelector("[data-subtitle-mob]").innerHTML = "";
        }
      } else {
        if (!nextRewardShowed) {          
          nextRewardShowed = true;
          const prevStep = this.dynamicData[index - 1];
          const prevStepRequirements = (prevStep?.requirements || 0) * 100;
          const prevStepRequirementsLocalCurrency = Math.round(parseFloat(Shopify.currency.rate) * prevStepRequirements);

          const rewardDiff = stepRequirementsLocalCurrency - cartTotal;
          const rewardDiffMoney = window.upcartFormatMoney({ cents: rewardDiff });

          const rewardDiffPercentage = Math.round(((cartTotal - prevStepRequirementsLocalCurrency) / (stepRequirementsLocalCurrency - prevStepRequirementsLocalCurrency)) * 100);
        
          this.querySelector("[data-title]").innerHTML = step.title;
          this.querySelector("[data-subtitle-desk]").innerHTML = step.subtitleDesktop.replace("{{ left_to_reach }}", rewardDiffMoney);
          this.querySelector("[data-subtitle-mob]").innerHTML = step.subtitleMobile.replace("{{ left_to_reach }}", rewardDiffMoney);
          preogressBar.setAttribute("data-bar", window.upcartFormatMoney({ cents: cartTotal }));
          preogressBar.style.width = rewardDiffPercentage + "%";
          
          if (index === 0) {
            stepBlock.classList.remove("completed");
          }
        } else {
          stepBlock.classList.remove("completed");
          preogressBar.style.width = "0%";
          preogressBar.setAttribute("data-bar", "");
        }
      }
    });
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "toggle-block":
            if (this.classList.contains("animate")) {
              this.classList.remove("animate");
              setTimeout(() => this.classList.remove("animate-prepare"), 320);
            } else {
              this.classList.add("animate-prepare");
              setTimeout(() => this.classList.add("animate"), 320);
            }
            break;
          case "open-popup":
            this.querySelector(".ts-tier-reward__popup").classList.add('open');
            document.documentElement.style.overflow = "hidden";
            break;
          case "close-popup":
            this.querySelector(".ts-tier-reward__popup").classList.remove('open');
            document.documentElement.style.overflow = null;
            break;
          case "toggle-info":
            const block = e.target.nextElementSibling;

            console.log(block);
            
    
            this.classList.toggle('open');
            block.style.maxHeight = this.classList.contains('open') ? block.scrollHeight + 'px' : null;
            break;
        }
      }
    })
  }
}

customElements.define("ts-tier-rewards", TSTierRewards);